export default function HomeAppearance() {
    return (
        <div>
            Home Appearance Page
        </div>
    )
}